import seed from 'seed-random';
import { Tile } from '../types';

// TODO: refactor card generator logic 
// Use existing options to generate losing and winning cards 
export const generateWinningCard = (options: Tile[], hits: string, userId: string): Tile[][] => {

  let winningMatrix = [
    [//1
      [0,0,1,1,1],
      [0,0,1,1,0],
      [0,0,1,0,0],
      [0,1,0,0,0],
      [1,1,0,0,1]
    ],
    [//2
      [0,1,0,0,0],
      [0,1,0,0,0],
      [0,1,1,0,1],
      [0,1,0,1,0],
      [0,1,0,0,0]
    ],
    [//3
      [1,0,0,1,1],
      [0,0,0,1,0],
      [0,0,1,1,0],
      [0,0,0,1,0],
      [0,0,1,1,0]
    ],
    [//4
      [1,1,0,0,0],
      [0,1,0,1,0],
      [0,1,1,0,0],
      [1,0,0,1,0],
      [0,0,0,0,1]
    ],
    [//5
      [1,0,0,1,0],
      [0,0,0,0,0],
      [0,0,1,0,0],
      [0,0,1,0,0],
      [1,1,1,1,1]
    ]
  ];

  const rand = seed(hits + userId);

  return generateCard(rand, winningMatrix, options, hits);
}

export const generateLosingCard = (options: Tile[], hits: string): Tile[][] => {
  //Define losing matrixes (Row/column inverted.  B is row 0, I is row 1, etc...)
  let losingMatrix = [
    [//1
      [0,0,1,1,0],
      [0,0,1,0,0],
      [0,0,1,1,0],
      [0,1,0,0,0],
      [1,1,0,0,1]
    ],
    [//2
      [0,0,1,0,0],
      [0,1,0,0,0],
      [0,1,1,0,1],
      [0,1,0,1,0],
      [0,1,0,0,0]
    ],
    [//3
      [1,0,0,1,1],
      [1,0,0,1,0],
      [1,0,1,0,0],
      [0,0,0,1,0],
      [0,0,1,0,0]
    ],
    [//4
      [1,1,0,0,0],
      [0,1,0,1,0],
      [0,1,1,0,0],
      [1,0,0,1,1],
      [0,0,0,0,0]
    ],
    [//5
      [1,1,0,1,0],
      [0,0,0,0,0],
      [0,0,1,0,0],
      [1,0,1,0,0],
      [0,0,1,1,1]
    ],
    [//6
      [0,0,0,0,0],
      [1,0,1,1,0],
      [0,0,1,1,0],
      [0,0,0,0,0],
      [1,1,1,1,0]
    ],
    [//7
      [0,0,0,0,1],
      [1,1,0,0,0],
      [0,0,1,0,1],
      [0,0,0,1,0],
      [0,1,1,1,1]
    ],
    [//8
      [1,0,0,0,0],
      [0,1,0,1,1],
      [0,0,1,0,0],
      [1,1,0,0,0],
      [1,1,0,0,0]
    ],
    [//9
      [0,1,0,0,0],
      [0,0,0,1,0],
      [1,1,1,0,0],
      [0,1,1,0,0],
      [0,1,1,0,0]
    ],
    [//10
      [0,0,0,0,0],
      [1,1,0,0,1],
      [1,1,1,0,0],
      [0,0,1,1,0],
      [0,0,1,1,0]
    ]
  ];

  return generateCard(Math.random, losingMatrix, options, hits);
}

const generateCard = (rand: () => number, matrix: number[][][], options: Tile[] ,hitString: string): Tile[][] => {
  let hits = hitString.split(',');
  let hitNumbers: number[] = [];

  hits.forEach((number, index) => {
      hitNumbers.push(parseInt(number,10));
  })

  let hitArray: Array<Array<number>> = [[],[],[],[],[]];
  let missArray: Array<Array<number>> = [[],[],[],[],[]];

  //sort hits and misses by BINGO letter.
  for(let i=1; i<=75; i++) {
    let col = Math.floor((i-1)/15);

    if(hitNumbers.indexOf(i) > -1) {
      hitArray[col].push(i);
    } else {
      missArray[col].push(i);
    }
  }

  //select random losing matrix;
  let randMatrixIndex = Math.floor(rand() * (matrix.length - 1));
  let template = matrix[randMatrixIndex];
  let newCard: Array<Array<string>> = [[],[],[],[],[]];

  /**
  row_id relates to BINGO lists: B=0...O=4
  */
    template.forEach((row, row_id) => {

    //each row denotes a list of hits or misses for the row (BINGO)
    for(let col_id = 0; col_id <= 4; col_id++) {
      //skip middle square
      if (col_id === 2 && row_id === 2) {
        newCard[row_id].push('X');
      }

      if (row[col_id]) {
        //pull hit
        let hit = pullHit(rand, newCard[row_id], hitArray[row_id], missArray[row_id], row_id*15);
        newCard[row_id].push(hit);
      } else {
        //pull miss
        let miss = pullMiss(rand, newCard[row_id], hitArray[row_id], missArray[row_id], row_id*15);
        newCard[row_id].push(miss);
      }
    }
  });

  let transposedCard = transposeArray(newCard,5) as (number | string)[][];

  const card = transposedCard.map((row) => (
    row.map((tile) => (
      tile === 'X'? { center: true } : options[(tile as number) - 1]
    ))
  ));
  
  return card;
}

const pullHit = (rand: () => number, currentList: string[], hits: number[], misses: number[], offset: number): any => {
  let hit = null;

  //safety check for case of all hits consumed for this set of numbers
  if (hits.length === 0) {
    //are equal, fill with a miss.
    hit = pullMiss(rand, currentList, hits, misses, offset);
  } else {

      let randIndex = Math.floor(rand() * hits.length);
      hit = hits[randIndex];
      hits.splice(randIndex, 1);

  }

  return hit;
}

const pullMiss = (rand: () => number, currentList: string[], hits: number[], misses: number[], offset: number) => {
  let miss = null;

  if (misses.length === 0) {
    //are equal, fill with a Hit.
    //TODO: reevaluate this logic after Shayna's response.
    //  I figured it would be better to add an extra hit than to watch the system break.
    miss = pullHit(rand, currentList, hits, misses, offset);
  } else {

      let randIndex = Math.floor(rand() * misses.length);
      miss = misses[randIndex];
      misses.splice(randIndex, 1);

  }

  return miss;
}

const transposeArray = (array: string[][], arrayLength: number) => {

    let newArray: Array<any> = [];
    for(let i = 0; i < array.length; i++){
        newArray.push([]);
    };

    for(let i = 0; i < array.length; i++){
        for(let j = 0; j < arrayLength; j++){
            newArray[j].push(array[i][j]);
        };
    };

    return newArray;
}